var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.42 12.19",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.42,3.82C17.42,1.71,15.71,0,13.6,0H3.82C1.71,0,0,1.71,0,3.82v4.55c0,2.11,1.71,3.82,3.82,3.82h9.77 c2.11,0,3.82-1.71,3.82-3.82V3.82z M11.67,6.44L7.29,8.61C7.12,8.7,6.53,8.57,6.53,8.38V3.93c0-0.2,0.59-0.32,0.76-0.22l4.2,2.28 C11.66,6.09,11.85,6.34,11.67,6.44z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.a5afc7ad187ca8997986016ee1a80960.svg";
export { ForwardRef as ReactComponent };